import React, { useState, useEffect } from "react";
import '../servicecalendar.css';

export const ServiceCalendarPopupAddEvent = ({
    displayStyle,
    date,
    vehicle,
    left,
    top
}) => {
    return (
        <div
            style={{
                width: '11em',
                display: displayStyle,
                left: left,
                top: top,
                position: "absolute",
                background: "white", 
                border: "1px solid lightgrey",
                boxShadow: '5px 4px 4px rgba(10, 10, 10, 0.4)',
                zIndex: "1000"
            }}
        >
            <div style={{ width: '100%', height: '10px', background: 'rgba(36, 119, 168, 1)' }}></div>
            <div style={{ width: '100%', padding: '10px' }}>
                <div style={{ width: '100%', display: 'flex' }}>
                    <div style={{ width: '38%', display: 'flex', alignItems: 'center' }}>
                        Date
                    </div>
                    <input type="text" style={{ width: '62%', border: '1px solid grey' }} value={date}/>
                </div>
                <div style={{ width: '100%', display: 'flex', marginTop: '6px' }}>
                    <div style={{ width: '38%', display: 'flex', alignItems: 'center' }}>
                        Vehicle
                    </div>
                    <input type="text" style={{ width: '62%', border: '1px solid grey' }} value={vehicle}/>
                </div>
                <button className="btn-action-in-popup">Add service Type</button>
            </div>
        </div>
    );
};
